@use "../../styles/layout";

.pageContentContainer {
    max-width: layout.$pageMaxWidth;
    margin-left: auto;
    margin-right: auto;
    padding-top: layout.$gridGap;
    padding-bottom: layout.$gridGap;
}
